import { css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { Style } from "./Styles";
import { BaseElement } from "./BaseElement";
import { MapBounds } from "../Kernel";
import { Geo, GeoSourceType } from "../geo/Geo";

import "./map/PlacesMap";
import { watch } from "./internal/watch";

@customElement("ds-geo-viewer")
export class GeoViewer extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }

            ds-places-map {
                width: 100%;
                height: 100%;
            }
        `,
    ];

    @property({ type: String }) type: GeoSourceType = "kml";
    @property({ type: String }) src: string | undefined;

    @watch(["type", "src"])
    async onChanged() {
        if (this.type && this.src) {
            await this._loadData(this.type, this.src);
        }
    }

    @state() protected _bounds: MapBounds | undefined;

    public override async connectedCallback(): Promise<void> {
        super.connectedCallback();
        await this._loadData(this.type, this.src);
    }

    private async _loadData(type: GeoSourceType | undefined, url: string | undefined) {
        this._bounds = undefined;
        if (type && url && url.length > 0) {
            const geo = await Geo.createFromUrl(type, url);
            if (geo) {
                this._bounds = geo.bbox();
            }
        }
    }

    override render() {
        return html`<ds-places-map
            .mapBounds=${this._bounds}
            noMyLocationButton
            noControls
        ></ds-places-map>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-geo-viewer": GeoViewer;
    }
}
